// ResourceGrid.tsx
import React from 'react';
import ResourceCard from './ResourceCard';
import { Resource } from '../common/types';
import { useAppSelector } from '../redux/hooks';


interface ResourceGridProps {
    resources: Resource[];
    onResourceClick: (resource: Resource) => void;
}

const ResourceGrid: React.FC<ResourceGridProps> = ({ resources, onResourceClick }) => {
    const searchTerm = useAppSelector((state) => state.search.terms["resourcesSearch"]);

    const filteredResources = resources.filter(resource =>
        (!searchTerm) ||
        (searchTerm && resource.title.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (searchTerm && resource.subtitle.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (searchTerm && resource.tag && resource.tag.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    return (
        <div className="mx-auto w-full max-w-screen-xl justify-items-center grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 md:gap-4 xl:gap-4">
            {filteredResources.map(resource => (
                <div key={resource.id} onClick={() => onResourceClick(resource)}>
                    <ResourceCard key={resource.id} {...resource} />
                </div>
            ))}
        </div>
    );
};

export default ResourceGrid;
